<template>
  <div class="pos-multi-select" :class="{'is-open': open && !disabled, 'is-disabled': disabled}">
    <div class="pos-multi-select__title" @click="handleTitleClick">
            <span v-if="!value || disabled">
                <slot></slot>
            </span>
      <template v-else>
                <span>
                    {{ title(getOptionByValue(value)) }}
                </span>
      </template>
    </div>
    <div class="pos-multi-select__list" v-if="open && !disabled">
      <div
          class="pos-multi-select__option"
          v-for="(option, i) in options"
          :key="option.id"
      >
        <input
            type="radio"
            :name="name"
            :id="uuid(i + '-' + option.id)"
            :value="option.id"
            :checked="isActive(option.id)"
            @click="selectOption(option)"
        >
        <label :for="uuid(i + '-' + option.id)">
          {{ title(option) }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import uuid from "../mixins/uuid";
import selectable from "../mixins/selectable";

export default {
  name: "SingleSelect",
  mixins: [
    uuid,
    selectable
  ],
  data() {
    return {
      open: this.active
    }
  },
  props: {
    disabled: Boolean,
    forceClose: Boolean,
    name: String,
    options: {
      type: Array,
      default: () => []
    },
    title: {
      type: Function,
      default: (s) => s
    },
    active: {
      type: Boolean,
      default: () => true
    },
  },
  watch: {
    options: 'cleanModelValue',
    disabled: 'reset',
    forceClose() {
      if (this.forceClose) {
        this.open = false;
      }
    },
    active() {
      this.open = this.active;
    },
  },
  methods: {
    getOptionByValue(id) {
      const found = this.options.find(o => o.id === id);
      if (found) {
        return found;
      }
      return null;
    },
    cleanModelValue() {
      this.$emit('input', null);
    },
    handleTitleClick() {
      if (!this.disabled) {
        this.open = !this.open;
      }
    },
    reset() {
      this.$emit('input', null);
    },
    selectOption(option) {
      this.handleClick(option.id);
      this.open = !this.open;
    }
  }
}
</script>
